import React, {memo, useEffect, useMemo, useRef, useState} from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import withHistoryObject from "../../components/hoc/withHistoryObject";
import withSplashScreenNavigation from "../../components/hoc/withSplashScreenNavigation";
import {
    REQUEST_KEY_RECEIVABLE,
    requestMonthlyReceivableData,
    requestMonthStatement,
}from "./states/actions";
import {
    REQUEST_STATE_LOADING,
    REQUEST_STATE_ERROR,
    REQUEST_STATE_STAND_BY,
  } from "../../common/states/actions.request";
import { subscribeToRequestState } from "../../common/states/reducers";
import { subscribeToUser } from "../venueSelection/states/reducers";
import {subscribeToReceivable} from "./states/reducers"
import {
    getDropDownOptionList,
    getStateFormattedDate,
    getMonthFormattedDate,
    getOption,
} from "../businessMetrics/index";
import mapReceivableDataToReceivableMainCardUi from "./mappings/mappingReceivableMainCard"
//import components
import CoSectionWithDropDown from "../../components/CoSectionWithDropDown";
import NavigationBar from "../../routes/NavigationBar";
import { LoadingByRequestState } from "../../components/LoadingScreen";
import { Error, EmptyCard, CoErrorScreen } from "../../components/EmptyScreen";
import ReceivableMainCard from "./components/receivableMainCard"


const getInitialMonthData = () => {
    const {
        optionList= [],
        selectedOption= {},
        selectedStateFormattedDate= "NA",
    } = getDropDownOptionList(-1)
    return {
        optionList,
        selectedOption,
        selectedStateFormattedDate,
    }
}


const Receivable = (props)=>{
    // variables
    const [selectedMonthData, setSelectedMonthData] = useState(useMemo(getInitialMonthData,[]));
    const [templateData, setTemplateData] = useState({})
    const downloadRef = useRef()
    const{
        api: {
            request_state: requestState,
            loading: { message: loadingMessage="" } = {},
            error: { message: errorMessage, code: errorCode } = {},
        },
        user: {
            selected_venue: { venue_id: venueId , venue_name:venueName},
        },
        requestMonthlyReceivableData,
        receivable:{
            monthly_receivable_list: {
                [selectedMonthData.selectedStateFormattedDate]: data = null
            } = {}
        }={}
    } = props
    
 
    // functions 
    const getReceivableData = ()=>{
        const{
            receivable:{
                monthly_receivable_list: {
                    [selectedMonthData.selectedStateFormattedDate]: selectedMonthReceivable = null
                } = {}
            }={}
        } = props

        if (requestState !== REQUEST_STATE_LOADING) {
            if (selectedMonthReceivable !== null ) {
              console.log(
                "Data already exists. No need to call",
                selectedMonthData.selectedStateFormattedDate
              );
              return;
            }
      
            if (venueId !== undefined) {
                requestMonthlyReceivableData({venueId: venueId, selectedMonth: selectedMonthData.selectedStateFormattedDate})
            }
        }
    }

    const handleDownloadStatement = ()=>{
        const{
            receivable:{
                monthly_receivable_list: {
                    [selectedMonthData.selectedStateFormattedDate]: selectedMonthReceivable = null
                } = {}
            }={},
            requestMonthStatement
        } = props
        requestMonthStatement({venueId: venueId, selectedMonth: selectedMonthData.selectedStateFormattedDate, downloadRef: downloadRef.current})
    }
    // control rendring
    useEffect(()=>{
        getReceivableData(selectedMonthData.selectedStateFormattedDate)
    },[selectedMonthData])

    useEffect(()=>{
        const{
            receivable:{
                monthly_receivable_list: {
                    [selectedMonthData.selectedStateFormattedDate]: selectedMonthReceivable = null
                } = {}
            }={}
        } = props
        if(selectedMonthReceivable!=null){
            setTemplateData( mapReceivableDataToReceivableMainCardUi(data, selectedMonthData.selectedOption, handleDownloadStatement) )
        }
    },[props.receivable, selectedMonthData.selectedStateFormattedDate])

        
    const onDropDownOptionChanged = (option) =>{
        setSelectedMonthData((preState)=>( {
            ...preState,
            monthId: option.id,
            selectedOption: option,
            selectedStateFormattedDate: getStateFormattedDate(option.id),
        }))
    }

    return (
        <div>
          <NavigationBar title={"Receivables "} hasBackIcon={true} /> 
          <LoadingByRequestState
            message={loadingMessage}
            requestState={requestState}
          >
            <CoErrorScreen
              hasMargins={false}
              hasError={requestState === REQUEST_STATE_ERROR}
              isLoading={requestState === REQUEST_STATE_LOADING}
              message={errorMessage}
              statusCode={errorCode}
              onRetryButtonClicked={getReceivableData}
            >
              <div style={{ margin: "20px" }}>
                <CoSectionWithDropDown
                  title={"Details"}
                  optionList={selectedMonthData.optionList}
                  selectedOption={selectedMonthData.selectedOption}
                  onOptionChanged={onDropDownOptionChanged}
                >
                  <EmptyCard
                    hasMargins={false}
                    isEmpty={Object.keys(templateData)?.length === 0}
                    title={"No Receivables Found"}
                    subtitle={`No data available for the month of ${getMonthFormattedDate(
                        selectedMonthData.selectedOption.id
                    )}`}
                  >
                      
                     <ReceivableMainCard data={templateData?.data} />
                  </EmptyCard>
                </CoSectionWithDropDown>
                <a style={{display:"none"}} ref={downloadRef} download = {`WzRecon_${venueName}_${selectedMonthData.selectedStateFormattedDate}.xlsx`} ></a>
              </div>
            </CoErrorScreen>
          </LoadingByRequestState>
        </div>
      );
}


// ********* mapping with store and apis from here
const mapStateToProps = (state) => ({
    user: subscribeToUser(state),
    api: subscribeToRequestState(state, REQUEST_KEY_RECEIVABLE),
    receivable: subscribeToReceivable(state),
})
const mapDispatchToProps = (dispatch) => ({
    requestMonthlyReceivableData: (params) => dispatch(requestMonthlyReceivableData({ ...params })),
    requestMonthStatement: (params) => dispatch(requestMonthStatement({ ...params })),
});

const ComposedReceivable = compose(
withHistoryObject,
withSplashScreenNavigation
)(Receivable);

export default connect(
mapStateToProps,
mapDispatchToProps
)(ComposedReceivable);